module.exports = __webpack_public_path__ + "static/media/home_cbhr.39a4dd31.png";